import ShaderBase from "./_shaderBase.js";
import { fieldUniforms } from "./shader-chunks.js";
export default class Mesh extends ShaderBase {}
Mesh.prototype.defaultOptions = {
  color: 0x26b1aa,
  color2: 0x8566da,
  backgroundColor: 0x091e2d,
};
Mesh.prototype.fragmentShader =
  fieldUniforms +
  `
void main(){vec2 uv=gl_FragCoord.xy/iResolution;vec2 mouse=iMouse/iResolution-.5;vec2 a=vec2(.3+.22*sin(iTime*.24),.4+.22*cos(iTime*.31))+mouse*.12;vec2 b=vec2(.7+.2*cos(iTime*.19),.6+.25*sin(iTime*.23));float wa=exp(-dot(uv-a,uv-a)*6.);float wb=exp(-dot(uv-b,uv-b)*8.);float fold=.06*sin(uv.x*6.+sin(uv.y*5.+iTime*.2));vec3 c=mix(backgroundColor,color,clamp(wa*.85*intensity+fold,0.,1.));c=mix(c,color2,clamp(wb*.7*intensity,0.,1.));gl_FragColor=vec4(c,1.);}`;
